import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useTeacherLanguageGet = (teacherId) => {
  const requestUrl = `${API_BASE_URL}/api/v2/teacher-languages/${teacherId}/`;
  return useRestQuery(requestUrl, { skip: !teacherId });
};

export default useTeacherLanguageGet;
